export default __webpack_public_path__ + "static/media/CAPA_BACKGROUND.15a47732.png";